<dx-popup
  [visible]="isVisible"
  [dragEnabled]="true"
  [resizeEnabled]="true"
  [closeOnOutsideClick]="false"
  [showCloseButton]="true"
  [showTitle]="true"
  title="Pricing Steps"
  [width]="260"
  [height]="'auto'"
  [maxHeight]="600"
  [shading]="false"
  (onHidden)="onCloseClick()">

  <div *dxTemplate="let data of 'content'" class="popup-content" #wrapper>
    <div class="offset-table">

      <div class="metadata">
        <div class="row group-name">{{ config?.adjustmentType }}</div>
        <div class="row leg-type">{{ config?.expirationFull }}</div>
      </div>

      <dx-scroll-view>
        <div class="scroll">
          <div class="offset-row header-row">
            <div class="offset-cell offset-col">Offset</div>
            <div class="offset-cell strike-col">Strike</div>
            <div class="offset-cell price-col">Price</div>
          </div>

          <div class="offset-row"
               *ngFor="let row of rows">
            <div class="offset-cell offset-col">{{ row.offsetLabel }}</div>
            <div class="offset-cell strike-col" [ngClass]="getRowRoleCss(row)">{{ row.strike }}</div>
            <div class="offset-cell price-col" [ngClass]="getNetPriceClass(row)">
              <ng-container *ngIf="isPriceAvailable(row); else naTemplate">
                {{ row.column.price | currency:'USD':'symbol':'1.2-2' }}
              </ng-container>
              <ng-template #naTemplate>N/A</ng-template>
            </div>
          </div>
        </div>
      </dx-scroll-view>
    </div>

    <div class="settings">
      <div class="setting num-of-steps">
        <div class="label"># of Steps</div>
        <div class="input">
          <dx-number-box [(value)]="settings.numOfSteps"
                         [showSpinButtons]="true"
                         [min]="1"
                         [max]="isSuperUser ? null : 10"
                         [inputAttr]="{style: 'text-align: center;'}">
          </dx-number-box>
        </div>
      </div>
      <div class="setting step-size">
        <div class="label">Step Size</div>
        <div class="input">
          <dx-number-box *ngIf="isSuperUser"
                         [(value)]="settings.stepSize"
                         [showSpinButtons]="true"
                         [step]="getStrikeStep()"
                         [min]="getStrikeStep()"
                         [inputAttr]="{style: 'text-align: center;'}">
          </dx-number-box>
          <dx-select-box *ngIf="!isSuperUser"
                         [(value)]="settings.stepSize"
                         [items]="allowedStepSizes"
                         [inputAttr]="{style: 'text-align: center;'}">
          </dx-select-box>
        </div>
      </div>
    </div>

    <div class="buttons">
      <div class="btn">
        <dx-button text="Apply" width="100%" (onClick)="applySettings()"></dx-button>
      </div>
      <div class="btn">
        <dx-button text="Close" width="100%" (onClick)="onCloseClick()"></dx-button>
      </div>
    </div>

    <dx-load-panel [visible]="isLoading" [position]="{my: 'center', at: 'center', of: wrapper}">
    </dx-load-panel>
  </div>
</dx-popup>
